import React, { useEffect, useState } from "react";
import { ArrowRight, WhatsappLogo } from "@phosphor-icons/react";

/**
 * Slim bottom bar shown ONLY on mobile after the user scrolls past the hero.
 * Hides itself when the #contact section is on screen so it doesn't overlap
 * the primary contact form.
 */
export default function MobileStickyCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const past = window.scrollY > 520;
      const contact = document.getElementById("contact");
      let overContact = false;
      if (contact) {
        const r = contact.getBoundingClientRect();
        overContact = r.top < window.innerHeight - 80;
      }
      setVisible(past && !overContact);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="mobile-sticky-cta"
      data-active={visible ? "true" : undefined}
      className={`md:hidden fixed bottom-0 left-0 right-0 z-40 border-t border-[color:var(--line)] bg-white/95 backdrop-blur-lg transition-transform duration-300 ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
      aria-hidden={!visible}
    >
      <div className="flex items-stretch">
        <a
          href="#contact"
          data-testid="mobile-cta-quote"
          className="flex-1 flex items-center justify-center gap-2 bg-[color:var(--brand)] text-white font-semibold py-3.5 text-sm hover:bg-[color:var(--brand-dark)] transition-colors"
        >
          Get a quote <ArrowRight size={14} weight="bold" />
        </a>
        <a
          href="https://wa.me/7054986771?text=Hi%20Maxine%2C%20I%27d%20like%20a%20quote%20for%20my%20project."
          target="_blank"
          rel="noreferrer"
          data-testid="mobile-cta-whatsapp"
          aria-label="Chat on WhatsApp"
          className="w-14 flex items-center justify-center bg-[#25D366] text-white hover:bg-[#1eb555] transition-colors"
        >
          <WhatsappLogo size={20} weight="fill" />
        </a>
      </div>
    </div>
  );
}
